import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { WhoFor } from './components/TargetAudience';
import { Problem } from './components/Problem';
import { Agitation } from './components/Agitation';
import { Solution } from './components/Solution';
import { Author } from './components/Author';
import { Modules } from './components/Modules';
import { Preview } from './components/Preview';
import { Bonus } from './components/Bonus';
import { SocialProof } from './components/SocialProof';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { FloatingCTA } from './components/FloatingCTA';
import { initPixel } from './lib/pixel';
import { bootPerf } from './lib/perf';
export function App() {
  useEffect(() => {
    bootPerf();
    initPixel();
  }, []);
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <div className="cv-auto" data-id="element-4">
          <WhoFor data-id="element-5" />
        </div>
        <div className="cv-auto" data-id="element-6">
          <Problem data-id="element-7" />
        </div>
        <div className="cv-auto" data-id="element-8">
          <Agitation data-id="element-9" />
        </div>
        <div className="cv-auto" data-id="element-10">
          <Solution data-id="element-11" />
        </div>
        <div className="cv-auto" data-id="element-12">
          <Author data-id="element-13" />
        </div>
        <div className="cv-auto" data-id="element-14">
          <Modules data-id="element-15" />
        </div>
        <div className="cv-auto" data-id="element-16">
          <Preview data-id="element-17" />
        </div>
        <div className="cv-auto" data-id="element-18">
          <Bonus data-id="element-19" />
        </div>
        <div className="cv-auto" data-id="element-20">
          <SocialProof data-id="element-21" />
        </div>
        <div className="cv-auto" data-id="element-22">
          <Pricing data-id="element-23" />
        </div>
        <div className="cv-auto" data-id="element-24">
          <Guarantee data-id="element-25" />
        </div>
        <div className="cv-auto" data-id="element-26">
          <FAQ data-id="element-27" />
        </div>
        <div className="cv-auto" data-id="element-28">
          <FinalCTA data-id="element-29" />
        </div>
      </main>
      <div className="cv-auto" data-id="element-30">
        <Footer data-id="element-31" />
      </div>
      <StickyMobileCTA data-id="element-32" />
      <FloatingCTA data-id="element-33" />
    </div>;
}